export default __webpack_public_path__ + "static/media/AcornMallFastFood_21.db652570.png";